<template lang="pug">
  .payouts
    v-row(no-gutters)
      v-col.py-2.px-4(@click="detailsSheet = true")
        v-row(no-gutters align="center")
          v-col
            div.font-weight-bold.s2.basic1000--text {{ $t('sales_date') }}: {{ slctPayout.sales_date | displayDate }}
        v-row.mt-2(no-gutters)
          v-col(cols="8")
            div.c1.basic600--text {{ $t('payout_amount') }}: {{ slctPayout.amount | displayPrice}}
          v-col
            div.c1.basic600--text {{ slctPayout.transaction_count > 1 ? slctPayout.transaction_count + ' transactions' : slctPayout.transaction_count + ' transaction' }}
        //- v-row.mt-2
          div.c1.basic600--text Payout amount: {{ slctPayout.amount | displayPrice}}
          v-spacer
          div.c1.basic600--text {{ slctPayout.transaction_count > 1 ? slctPayout.transaction_count + ' transactions' : slctPayout.transaction_count + ' transaction' }}
          v-spacer

    .bottomSheet
      y-bottom-sheet(v-model='detailsSheet' inset scrollable max-width="600px" )
        v-card.pt-4.pb-6(flat)
          div.px-4.pb-3
            div.d-flex.align-center
              div.font-weight-bold.s1.basic1000--text {{ $t('sales_date') }}: {{ slctPayout.sales_date | displayDate }}
              v-spacer
              div.p2.basic600--text {{ $t('amount') }}: {{ slctPayout.amount | displayPrice }}
            //- v-row.mt-2(no-gutters)
              v-col
                div.p2.basic600--text Amount: {{ slctPayout.amount | displayPrice }}
              v-col
                div.p2.basic600--text Charges: {{ slctPayout.charge | displayPrice }}
          v-card-text.pa-0
            template(v-for="(transaction, idx) in slctPayout.transactions")
              v-row(no-gutters)
                v-col(cols="2" align ="center")
                  div.font-weight-bold.s1.basic1000--text(style="margin-top: 2px") {{ idx + 1 }}
                v-col.pr-4
                  div(link @click="clickOpenReceipt(transaction.lead)")
                    strong.s2.basic1000--text.payout-title #
                      | {{ transaction.lead.rid }} {{ transaction.paid_datetime | convertServerDate }}
                  div.c1.basic600--text {{ $t('name') }}: {{ transaction.lead.name }}
                  div.c1.basic600--text {{ $t('amount') }}: {{ transaction.amount | displayPrice }}
              v-divider.basic300.my-1

    .modals
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'

export default {
  name: 'PayoutItem',
  props: ['payout', 'index'],
  components: { ProductInvoice },
  data: (vm) => ({
    openInvoiceDialog: false,
    slctPayout: vm.payout,
    detailsSheet: false,
    lead: null
  }),
  computed: {
    ...mapState('user', ['member']),
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickOpenReceipt(lead) {
      this.$axios.get(`/leads/${lead.pid}/`)
        .then((resp) => {
          this.lead = resp.data
          this.openInvoiceDialog = true
        })
        .catch(() => {})
    },
    chipBackgroundColor (paid) {
      const theme = this.$vuetify.theme.themes[this.$theme]
      return paid ? theme.successT08 : theme.dangerT08
    }
  }
}
</script>

<style scoped>
  .payout-title:hover{
    text-decoration: underline;
    cursor: pointer;
  }
  .border-bottom{
    border-bottom: 1px solid #f4f4f4;
    border-radius: 0 !important;
  }
</style>
